import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import './_header.scss';
var Header = /*#__PURE__*/function (_Component) {
  function Header() {
    var _this;
    _classCallCheck(this, Header);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Header, [].concat(args));
    _defineProperty(_this, "goBack", function (event) {
      event.preventDefault();
      _this.props.history.goBack();
    });
    return _this;
  }
  _inherits(Header, _Component);
  return _createClass(Header, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "teams-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, this.props.settings.backButton ? /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: this.goBack,
        className: "c--button back"
      }, /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          transform: 'rotate(90deg)'
        },
        className: "a-90"
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })))) : null, this.props.title != null ? /*#__PURE__*/React.createElement("div", {
        className: "page-title",
        title: this.props.title
      }, this.props.title) : null)));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    title: state.Header.title,
    settings: state.Header
  };
}
export default withRouter(connect(mapStateToProps)(Header));